import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import RunSync from "./routes/Logs";
import ExistingDataMapping from "./routes/ExistingDataMapping";
import SubjectMapping from "./routes/SubjectMapping";
import GradesMapping from "./routes/GradesMapping";
import sisDataExclusion from "./routes/SisDataExclusion";
import ToddleDataExclusion from "./routes/ToddleDataExclusion";
import SyncSettings from "./routes/SyncSettings";

export default store => ({
  path: "roster",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    RunSync(store),
    ExistingDataMapping(store),
    SubjectMapping(store),
    GradesMapping(store),
    sisDataExclusion(store),
    ToddleDataExclusion(store),
    SyncSettings(store),
  ],
});
